import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { ACCEPT_DATE_FORMAT, INPUT_MASK_DATE_FORMAT, ISODATE_FORMAT } from './date-format';

@Injectable()
export class CustomNgbDateParser extends NgbDateParserFormatter {
  /**
   * Parses the entered date (Buddhist-era `dd/mm/yyyy` or ISO `yyyy-mm-dd`)
   * into a common-era `NgbDateStruct`.
   */
  parse(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }
    if (INPUT_MASK_DATE_FORMAT.test(value)) {
      if (ACCEPT_DATE_FORMAT.test(value)) {
        const parts = value.split('/');
        return { year: Number(parts[2]) - 543, month: Number(parts[1]), day: Number(parts[0]) };
      }
    } else if (ISODATE_FORMAT.test(value)) {
      try {
        const source = new Date(value);
        const date = new Date(source.getFullYear() - 543, source.getMonth(), source.getDate());
        return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
      } catch (error) {
        console.warn(error);
      }
    }
    return null;
  }

  /** Formats a common-era `NgbDateStruct` into a Thai locale string. */
  format(date: NgbDateStruct | null): string {
    if (!date) {
      return '';
    }
    const value = new Date(date.year, date.month - 1, date.day);
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return value.toLocaleString('th-TH', options);
  }
}
